module.exports = __webpack_public_path__ + "assets/img/bb7b30b4f336a75f0a5fe722a642875c.png";